import { useMutation } from "@tanstack/react-query";
import { createOrgStructureItem as apiCreate } from "../../api/apiOrgStructureItems";
import { useSnackbar } from "notistack";
import { useNavigate } from "react-router-dom";
import getErrorMessageFromAxiosError from "../../utils/parseError";

export function useCreateOrgStructureItem() {
    const navigate = useNavigate();
    const { enqueueSnackbar } = useSnackbar();
    const { mutate: createOrgStructureItem, isPending, error } = useMutation({
        mutationFn: (req) => apiCreate(req),
        onSuccess: (r) => { enqueueSnackbar(r.message, { variant: "success" }); navigate('/org-structure-items'); },
        onError: (err) => { enqueueSnackbar(getErrorMessageFromAxiosError(err), { variant: "error" }); },
    });
    return { isPending, error, createOrgStructureItem };
}
